import React from 'react';

const Footer = (props) => {
    return (
        <div className="footer-container">
            <footer className="bg-primary short-2">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <span className="text-white">Manish Thakur | Full Stack Developer</span>
                            <br />
                            <br />
                            <i className="icon text-white icon_mail"></i>
                            <a href="mailto: programmerwebapps@gmail.com" className="text-white">
                            <span className="text-white">&nbsp;Get in touch with me <i className="icon arrow_right"></i>
                            </span>
                            </a>
                        </div>
                    </div>
                </div>                
            </footer>
        </div>
    )
}

export default Footer;